import Alpine from 'alpinejs';

Alpine.data('steppedScroll', () => ({
    boundScroll: null,
    ticking: false,
    mq: null,
    steps: [],

    init() {
        this.mq = window.matchMedia('(min-width: 1024px)');
        this.boundScroll = () => this.onScroll();
        this.steps = Array.from(this.$el.querySelectorAll('[data-step]'));
        window.addEventListener('scroll', this.boundScroll, { passive: true });
        this.$nextTick(() => this.onScroll());
    },

    destroy() {
        if (this.boundScroll) {
            window.removeEventListener('scroll', this.boundScroll);
        }
    },

    onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
            this.updateStrokes();
            this.updateStepVisibility();
            this.ticking = false;
        });
    },

    updateStrokes() {
        if (!this.mq.matches) return;

        const revealPath = this.$refs.strokesPath;
        if (!revealPath) return;

        const section = this.$el;
        const sectionRect = section.getBoundingClientRect();
        const vh = window.innerHeight;

        // Begin shortly before the component reaches the middle of the viewport.
        const revealLine = vh * 0.55;
        const progress = Math.max(0, Math.min(1, (revealLine - sectionRect.top) / sectionRect.height));

        revealPath.style.strokeDashoffset = String(1 - progress);
    },

    updateStepVisibility() {
        if (!this.mq.matches) return;

        const vh = window.innerHeight;
        const threshold = vh * 0.2;

        this.steps.forEach((step) => {
            const rect = step.getBoundingClientRect();
            const isVisible = rect.top < (vh - threshold) && rect.bottom > threshold;

            if (isVisible) {
                step.classList.add('stepped-scroll__step--visible');
                step.classList.remove('stepped-scroll__step--hidden');
            } else {
                step.classList.remove('stepped-scroll__step--visible');
                step.classList.add('stepped-scroll__step--hidden');
            }
        });
    },
}));
